import { type FunctionComponent, memo } from 'react'

import { GenericProblemMessage } from './generic-problem-message.tsx'

export const Unauthorized: FunctionComponent<{ message?: string }> = memo(function Unauthorized({ message }) {
  return (
    <GenericProblemMessage
      title="Unauthorized"
      principalMessage="Accès restreint"
      firstSubText={
        message ?? "Il semblerait que vous tentiez d'accéder à une ressource à laquelle vous n'avez pas les droits."
      }
      secondSubText="Nous vous suggérons de revenir à la page précédente."
    />
  )
})
